import createVueApp from '@phoenix/createVueApp';
import ResetPasswordForm from '../components/form/myAccount/ResetPasswordForm.vue';

const app = createVueApp({}, true);
app.component('ResetPasswordForm', ResetPasswordForm);
app.mount('#phoenix-reset-password-form');
